import React, { lazy } from 'react';

// 面向机器人的页面
const SelectRobotModal = lazy(() => import('@/pages/robot/SelectRobotModal'));
const LoginForRobot = lazy(() => import('@/pages/robot/RobotLogin'));
const LoginForRobotByStdId = lazy(() => import('@/pages/robot/RobotLoginByStdId'));
const CognitionRepeat = lazy(() => import('@/pages/robot/Cognition/Repeat'));
const ClassifyRepeat = lazy(() => import('@/pages/robot/Cognition/Classify'));
const TrainingReview = lazy(() => import('@/pages/robot/Cognition/TrainingReview'));
const RepeatHistory = lazy(() => import('@/pages/robot/Cognition/RepeatHistory'));
const RepeatHistoryDetail = lazy(() => import('@/pages/robot/Cognition/RepeatHistoryDetail'));
const ClassifyHistory = lazy(() => import('@/pages/robot/Cognition/ClassifyHistory'));
const ClassifyHistoryDetail = lazy(() => import('@/pages/robot/Cognition/ClassifyHistoryDetail'));
const RegisterForRobot = lazy(() => import('@/pages/robot/RobotRegister'));

const PsychologicalAIConsultant = lazy(() => import('@/pages/robot/PsychologicalAIConsultant'));
const PsychologicalAIConsultantWithFormTest = lazy(() => import('@/pages/robot/PsychologicalAIConsultant/PsychologicalAIConsultantWithFormTest'));

const robotRoutes = [
  { path: '/robot/login', component: <LoginForRobot />, needInterceptor: false },
  { path: '/robot/login-std-id', component: <LoginForRobotByStdId />, needInterceptor: false },
  { path: '/robot/selectModal', component: <SelectRobotModal />, needInterceptor: true },
  { path: '/robot/register/:authId', component: <RegisterForRobot />, needInterceptor: false },
  { path: '/robot/psychological-ai-consultant', component: <PsychologicalAIConsultant />, needInterceptor: true },
  { path: '/robot/psychological-ai-consultant-with-form-test', component: <PsychologicalAIConsultantWithFormTest />, needInterceptor: true },
  { path: '/robot/cog-repeat', component: <CognitionRepeat />, needInterceptor: true },
  { path: '/robot/training-review', component: <TrainingReview />, needInterceptor: true },
  { path: '/robot/cog-classify', component: <ClassifyRepeat />, needInterceptor: true },
  { path: '/robot/repeat-history', component: <RepeatHistory />, needInterceptor: true },
  { path: '/robot/repeat-history-detail', component: <RepeatHistoryDetail />, needInterceptor: true },
  { path: '/robot/classify-history', component: <ClassifyHistory />, needInterceptor: true },
  { path: '/robot/classify-history-detail', component: <ClassifyHistoryDetail />, needInterceptor: true },
];

export default robotRoutes;
